import { TreeNodeRoute } from "./types/treeNode";

export type DropPosition = "above" | "inside" | "below";

export interface DropTarget {
    node: TreeNodeRoute;
    position: DropPosition;
}

/**
 * Regras:
 * - Não muda nível da árvore.
 * - Movimentação apenas entre irmãos.
 */
export function resolveDrop(
    moving: TreeNodeRoute,
    target: TreeNodeRoute,
    position: DropPosition,
    parentOfTarget: TreeNodeRoute | null,
    rootSiblings: TreeNodeRoute[],
    movingParent: TreeNodeRoute | null
): {
    allowed: boolean;
    newParent: TreeNodeRoute | null;
    insertIndex: number;
} {
    const movingParentId = movingParent ? movingParent.id : null;
    const targetParentId = parentOfTarget ? parentOfTarget.id : null;

    // Só permite reorder entre irmãos
    if (movingParentId !== targetParentId) {
        return { allowed: false, newParent: movingParent, insertIndex: -1 };
    }

    const parent = movingParent ?? null;
    const siblings = parent ? parent.children : rootSiblings;

    const fromIndex = siblings.findIndex(n => n.id === moving.id);
    const targetIndex = siblings.findIndex(n => n.id === target.id);

    if (fromIndex === -1 || targetIndex === -1) {
        return { allowed: false, newParent: parent, insertIndex: -1 };
    }

    const isBelow = position === "below" || position === "inside";

    let insertIndex = isBelow ? targetIndex + 1 : targetIndex;

    // Ajuste quando arrasta de cima para baixo:
    // ao remover o item, os índices mudam
    if (fromIndex < insertIndex) {
        insertIndex--;
    }

    // Garantir limites válidos
    insertIndex = Math.max(0, Math.min(insertIndex, siblings.length));

    return {
        allowed: true,
        newParent: parent,
        insertIndex
    };
}
